import * as React from 'react';
import * as TabsPrimitive from '@radix-ui/react-tabs';

import { cn } from '@/lib/utils';
import { TABS_OVERWRITES } from './_overwrites/tabs';
import { BaseTooltip } from '../uiKit';

const Tabs = TabsPrimitive.Root;

const TabsList = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.List ref={ref} className={cn(TABS_OVERWRITES.classNames.list, className)} {...props} />
));
TabsList.displayName = TabsPrimitive.List.displayName;

const TabsTrigger = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger> & {
    tooltip?: string;
  }
>(({ className, tooltip, children, ...props }, ref) => (
  <TabsPrimitive.Trigger ref={ref} className={cn(TABS_OVERWRITES.classNames.trigger, className)} {...props}>
    <BaseTooltip
      content={tooltip}
      side="bottom"
      sideOffset={13}
      classNames={{ content: '', trigger: props.disabled ? 'cursor-not-allowed' : '' }}
    >
      {children}
    </BaseTooltip>
  </TabsPrimitive.Trigger>
));
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;

TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;

const TabsContent = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Content ref={ref} className={cn(TABS_OVERWRITES.classNames.content, className)} {...props} />
));
TabsContent.displayName = TabsPrimitive.Content.displayName;

export { Tabs, TabsList, TabsTrigger, TabsContent };
